// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".p-favorite-select[data-v-5ff1e16e]{margin:0 15px}", ""]);
// Exports
module.exports = exports;
